// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36KaL","importantInfo":"styles_importantInfo__1LrEP"};